const $b2ebc7535321c5c8$var$BACK_RANK = [
    'R',
    'N',
    'B',
    'Q',
    'K',
    'B',
    'N',
    'R'
];
// Default row for virtual (unmaterialized) rows: all queens of the appropriate color
function $b2ebc7535321c5c8$var$defaultRow(r) {
    const color = r < 0 ? 'b' : 'w';
    return Array.from({
        length: 8
    }, ()=>({
            type: 'Q',
            color: color
        }));
}
function $b2ebc7535321c5c8$var$initialRow(r) {
    if (r === 0) return $b2ebc7535321c5c8$var$BACK_RANK.map((type)=>({
            type: type,
            color: 'b'
        }));
    if (r === 1) return Array.from({
        length: 8
    }, ()=>({
            type: 'P',
            color: 'b'
        }));
    if (r === 6) return Array.from({
        length: 8
    }, ()=>({
            type: 'P',
            color: 'w'
        }));
    if (r === 7) return $b2ebc7535321c5c8$var$BACK_RANK.map((type)=>({
            type: type,
            color: 'w'
        }));
    return new Array(8).fill(null);
}
class $b2ebc7535321c5c8$export$5f0f8d492a153731 {
    constructor(){
        this.rows = new Map();
        this.topBound = 0;
        this.bottomBound = 7;
        for(let r = 0; r <= 7; r++)this.rows.set(r, $b2ebc7535321c5c8$var$initialRow(r));
    }
    getCell(r, c) {
        if (r >= this.topBound && r <= this.bottomBound) return this.rows.get(r)[c];
        // Virtual row — return default piece without allocating
        const color = r < 0 ? 'b' : 'w';
        return {
            type: 'Q',
            color: color
        };
    }
    setCell(r, c, piece) {
        this.materialize(r);
        this.rows.get(r)[c] = piece;
    }
    get top() {
        return this.topBound;
    }
    get bottom() {
        return this.bottomBound;
    }
    clone() {
        const copy = Object.create($b2ebc7535321c5c8$export$5f0f8d492a153731.prototype);
        copy.rows = new Map();
        for (const [r, row] of this.rows)copy.rows.set(r, row.map((cell)=>cell ? {
                ...cell
            } : null));
        copy.topBound = this.topBound;
        copy.bottomBound = this.bottomBound;
        return copy;
    }
    materialize(r) {
        if (r >= this.topBound && r <= this.bottomBound) return;
        if (r < this.topBound) {
            for(let i = this.topBound - 1; i >= r; i--)this.rows.set(i, $b2ebc7535321c5c8$var$defaultRow(i));
            this.topBound = r;
        } else {
            for(let i = this.bottomBound + 1; i <= r; i++)this.rows.set(i, $b2ebc7535321c5c8$var$defaultRow(i));
            this.bottomBound = r;
        }
    }
}


function $4ab56ab556188d29$var$opponent(c) {
    return c === 'w' ? 'b' : 'w';
}
function $4ab56ab556188d29$var$inBounds(col) {
    return col >= 0 && col < 8;
}
// Slide along a direction until hitting a piece or column out of bounds.
// Rows are infinite but virtual rows are filled, so rays always terminate.
function $4ab56ab556188d29$var$slideRay(board, from, dr, dc, color) {
    const moves = [];
    let r = from.row + dr;
    let c = from.col + dc;
    while($4ab56ab556188d29$var$inBounds(c)){
        const cell = board.getCell(r, c);
        if (cell === null) moves.push({
            row: r,
            col: c
        });
        else {
            if (cell.color !== color) moves.push({
                row: r,
                col: c
            }); // capture
            break;
        }
        r += dr;
        c += dc;
    }
    return moves;
}
function $4ab56ab556188d29$export$af40cce609736e4e(board, from, lastMove, castlingRights) {
    const piece = board.getCell(from.row, from.col);
    if (!piece) return [];
    const { color: color, type: type } = piece;
    const moves = [];
    switch(type){
        case 'P':
            {
                const dir = color === 'w' ? -1 : 1;
                const startRow = color === 'w' ? 6 : 1;
                // Forward 1
                const f1 = from.row + dir;
                if (board.getCell(f1, from.col) === null) {
                    moves.push({
                        row: f1,
                        col: from.col
                    });
                    // Forward 2 from start
                    if (from.row === startRow) {
                        const f2 = from.row + dir * 2;
                        if (board.getCell(f2, from.col) === null) moves.push({
                            row: f2,
                            col: from.col
                        });
                    }
                }
                // Diagonal captures
                for (const dc of [
                    -1,
                    1
                ]){
                    const nc = from.col + dc;
                    if (!$4ab56ab556188d29$var$inBounds(nc)) continue;
                    const target = board.getCell(f1, nc);
                    if (target !== null && target.color !== color) moves.push({
                        row: f1,
                        col: nc
                    });
                }
                // En passant
                if (lastMove && lastMove.piece.type === 'P' && Math.abs(lastMove.to.row - lastMove.from.row) === 2 && lastMove.to.row === from.row && Math.abs(lastMove.to.col - from.col) === 1) moves.push({
                    row: from.row + dir,
                    col: lastMove.to.col
                });
                break;
            }
        case 'N':
            {
                const offsets = [
                    [
                        -2,
                        -1
                    ],
                    [
                        -2,
                        1
                    ],
                    [
                        -1,
                        -2
                    ],
                    [
                        -1,
                        2
                    ],
                    [
                        1,
                        -2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        2,
                        -1
                    ],
                    [
                        2,
                        1
                    ]
                ];
                for (const [dr, dc] of offsets){
                    const nr = from.row + dr;
                    const nc = from.col + dc;
                    if (!$4ab56ab556188d29$var$inBounds(nc)) continue;
                    const cell = board.getCell(nr, nc);
                    if (cell === null || cell.color !== color) moves.push({
                        row: nr,
                        col: nc
                    });
                }
                break;
            }
        case 'B':
            for (const [dr, dc] of [
                [
                    -1,
                    -1
                ],
                [
                    -1,
                    1
                ],
                [
                    1,
                    -1
                ],
                [
                    1,
                    1
                ]
            ])moves.push(...$4ab56ab556188d29$var$slideRay(board, from, dr, dc, color));
            break;
        case 'R':
            for (const [dr, dc] of [
                [
                    -1,
                    0
                ],
                [
                    1,
                    0
                ],
                [
                    0,
                    -1
                ],
                [
                    0,
                    1
                ]
            ])moves.push(...$4ab56ab556188d29$var$slideRay(board, from, dr, dc, color));
            break;
        case 'Q':
            for (const [dr, dc] of [
                [
                    -1,
                    -1
                ],
                [
                    -1,
                    0
                ],
                [
                    -1,
                    1
                ],
                [
                    0,
                    -1
                ],
                [
                    0,
                    1
                ],
                [
                    1,
                    -1
                ],
                [
                    1,
                    0
                ],
                [
                    1,
                    1
                ]
            ])moves.push(...$4ab56ab556188d29$var$slideRay(board, from, dr, dc, color));
            break;
        case 'K':
            {
                for (const [dr, dc] of [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        0
                    ],
                    [
                        -1,
                        1
                    ],
                    [
                        0,
                        -1
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        -1
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        1,
                        1
                    ]
                ]){
                    const nr = from.row + dr;
                    const nc = from.col + dc;
                    if (!$4ab56ab556188d29$var$inBounds(nc)) continue;
                    const cell = board.getCell(nr, nc);
                    if (cell === null || cell.color !== color) moves.push({
                        row: nr,
                        col: nc
                    });
                }
                // Castling
                const homeRow = color === 'w' ? 7 : 0;
                if (from.row === homeRow && from.col === 4) {
                    const opp = $4ab56ab556188d29$var$opponent(color);
                    // King-side
                    const ksRight = color === 'w' ? castlingRights.wK : castlingRights.bK;
                    if (ksRight && board.getCell(homeRow, 5) === null && board.getCell(homeRow, 6) === null && board.getCell(homeRow, 7)?.type === 'R' && board.getCell(homeRow, 7)?.color === color && !$4ab56ab556188d29$export$276cda437788073e(board, homeRow, 4, opp) && !$4ab56ab556188d29$export$276cda437788073e(board, homeRow, 5, opp) && !$4ab56ab556188d29$export$276cda437788073e(board, homeRow, 6, opp)) moves.push({
                        row: homeRow,
                        col: 6
                    });
                    // Queen-side
                    const qsRight = color === 'w' ? castlingRights.wQ : castlingRights.bQ;
                    if (qsRight && board.getCell(homeRow, 3) === null && board.getCell(homeRow, 2) === null && board.getCell(homeRow, 1) === null && board.getCell(homeRow, 0)?.type === 'R' && board.getCell(homeRow, 0)?.color === color && !$4ab56ab556188d29$export$276cda437788073e(board, homeRow, 4, opp) && !$4ab56ab556188d29$export$276cda437788073e(board, homeRow, 3, opp) && !$4ab56ab556188d29$export$276cda437788073e(board, homeRow, 2, opp)) moves.push({
                        row: homeRow,
                        col: 2
                    });
                }
                break;
            }
    }
    return moves;
}
function $4ab56ab556188d29$export$276cda437788073e(board, row, col, byColor) {
    // Knight attacks
    for (const [dr, dc] of [
        [
            -2,
            -1
        ],
        [
            -2,
            1
        ],
        [
            -1,
            -2
        ],
        [
            -1,
            2
        ],
        [
            1,
            -2
        ],
        [
            1,
            2
        ],
        [
            2,
            -1
        ],
        [
            2,
            1
        ]
    ]){
        const nc = col + dc;
        if (!$4ab56ab556188d29$var$inBounds(nc)) continue;
        const cell = board.getCell(row + dr, nc);
        if (cell && cell.color === byColor && cell.type === 'N') return true;
    }
    // Pawn attacks
    const pawnDir = byColor === 'w' ? 1 : -1; // pawns attack from this direction
    for (const dc of [
        -1,
        1
    ]){
        const nc = col + dc;
        if (!$4ab56ab556188d29$var$inBounds(nc)) continue;
        const cell = board.getCell(row + pawnDir, nc);
        if (cell && cell.color === byColor && cell.type === 'P') return true;
    }
    // King attacks
    for (const [dr, dc] of [
        [
            -1,
            -1
        ],
        [
            -1,
            0
        ],
        [
            -1,
            1
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ],
        [
            1,
            -1
        ],
        [
            1,
            0
        ],
        [
            1,
            1
        ]
    ]){
        const nc = col + dc;
        if (!$4ab56ab556188d29$var$inBounds(nc)) continue;
        const cell = board.getCell(row + dr, nc);
        if (cell && cell.color === byColor && cell.type === 'K') return true;
    }
    // Sliding attacks: rook/queen on straights, bishop/queen on diagonals
    for (const [dr, dc] of [
        [
            -1,
            0
        ],
        [
            1,
            0
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ]
    ]){
        let r = row + dr, c = col + dc;
        while($4ab56ab556188d29$var$inBounds(c)){
            const cell = board.getCell(r, c);
            if (cell !== null) {
                if (cell.color === byColor && (cell.type === 'R' || cell.type === 'Q')) return true;
                break;
            }
            r += dr;
            c += dc;
        }
    }
    for (const [dr, dc] of [
        [
            -1,
            -1
        ],
        [
            -1,
            1
        ],
        [
            1,
            -1
        ],
        [
            1,
            1
        ]
    ]){
        let r = row + dr, c = col + dc;
        while($4ab56ab556188d29$var$inBounds(c)){
            const cell = board.getCell(r, c);
            if (cell !== null) {
                if (cell.color === byColor && (cell.type === 'B' || cell.type === 'Q')) return true;
                break;
            }
            r += dr;
            c += dc;
        }
    }
    return false;
}
function $4ab56ab556188d29$export$51123a03fba7994c(board, color) {
    for(let r = board.top; r <= board.bottom; r++)for(let c = 0; c < 8; c++){
        const cell = board.getCell(r, c);
        if (cell && cell.type === 'K' && cell.color === color) return {
            row: r,
            col: c
        };
    }
    // Should never happen in a valid game
    throw new Error(`King not found for ${color}`);
}
function $4ab56ab556188d29$export$68463a02700ffafb(board, color) {
    const king = $4ab56ab556188d29$export$51123a03fba7994c(board, color);
    return $4ab56ab556188d29$export$276cda437788073e(board, king.row, king.col, $4ab56ab556188d29$var$opponent(color));
}
// Simulate a move on a cloned board (handles en passant and castling rook)
function $4ab56ab556188d29$var$simulateMove(board, from, to) {
    const clone = board.clone();
    const piece = clone.getCell(from.row, from.col);
    clone.setCell(to.row, to.col, piece);
    clone.setCell(from.row, from.col, null);
    // En passant capture
    if (piece.type === 'P' && to.col !== from.col && board.getCell(to.row, to.col) === null) clone.setCell(from.row, to.col, null);
    // Castling rook move
    if (piece.type === 'K' && Math.abs(to.col - from.col) === 2) {
        if (to.col === 6) {
            clone.setCell(from.row, 5, clone.getCell(from.row, 7));
            clone.setCell(from.row, 7, null);
        } else {
            clone.setCell(from.row, 3, clone.getCell(from.row, 0));
            clone.setCell(from.row, 0, null);
        }
    }
    return clone;
}
function $4ab56ab556188d29$export$fc786a30b8974380(board, from, lastMove, castlingRights) {
    const piece = board.getCell(from.row, from.col);
    if (!piece) return [];
    const pseudo = $4ab56ab556188d29$export$af40cce609736e4e(board, from, lastMove, castlingRights);
    return pseudo.filter((to)=>{
        const after = $4ab56ab556188d29$var$simulateMove(board, from, to);
        return !$4ab56ab556188d29$export$68463a02700ffafb(after, piece.color);
    });
}
function $4ab56ab556188d29$export$2919e2d100ec73fb(board, turn, lastMove, castlingRights) {
    // Check materialized pieces + frontier virtual rows
    const topFrontier = board.top - 1;
    const bottomFrontier = board.bottom + 1;
    for(let r = topFrontier; r <= bottomFrontier; r++)for(let c = 0; c < 8; c++){
        const cell = board.getCell(r, c);
        if (cell && cell.color === turn) {
            const legal = $4ab56ab556188d29$export$fc786a30b8974380(board, {
                row: r,
                col: c
            }, lastMove, castlingRights);
            if (legal.length > 0) // Has at least one legal move
            return $4ab56ab556188d29$export$68463a02700ffafb(board, turn) ? 'check' : 'playing';
        }
    }
    // No legal moves found
    return $4ab56ab556188d29$export$68463a02700ffafb(board, turn) ? 'checkmate' : 'stalemate';
}


class $e46db5192eb49d53$export$eb5ccdbd077479c {
    reset() {
        this.board = new (0, $b2ebc7535321c5c8$export$5f0f8d492a153731)();
        this.selected = null;
        this.turn = 'w';
        this.lastMove = null;
        this.castlingRights = {
            wK: true,
            wQ: true,
            bK: true,
            bQ: true
        };
        this.status = 'playing';
        this.legalMoves = [];
        this.pendingPromotion = null;
        this.moveLog = [];
        this.captures = {
            w: [],
            b: []
        };
        this.pendingNotation = '';
    }
    click(row, col) {
        if (this.pendingPromotion) return;
        if (this.status === 'checkmate' || this.status === 'stalemate') return;
        // No piece selected yet
        if (this.selected === null) {
            const piece = this.board.getCell(row, col);
            if (piece && piece.color === this.turn) {
                this.selected = {
                    row: row,
                    col: col
                };
                this.legalMoves = (0, $4ab56ab556188d29$export$fc786a30b8974380)(this.board, {
                    row: row,
                    col: col
                }, this.lastMove, this.castlingRights);
            }
            return;
        }
        const { row: sr, col: sc } = this.selected;
        // Click same square → deselect
        if (sr === row && sc === col) {
            this.selected = null;
            this.legalMoves = [];
            return;
        }
        // Click another own piece → reselect
        const clickedPiece = this.board.getCell(row, col);
        if (clickedPiece && clickedPiece.color === this.turn) {
            this.selected = {
                row: row,
                col: col
            };
            this.legalMoves = (0, $4ab56ab556188d29$export$fc786a30b8974380)(this.board, {
                row: row,
                col: col
            }, this.lastMove, this.castlingRights);
            return;
        }
        // Check if target is a legal move
        if (!this.legalMoves.some((m)=>m.row === row && m.col === col)) return;
        const piece = this.board.getCell(sr, sc);
        // Compute notation before executing move
        const isCapture = clickedPiece !== null || piece.type === 'P' && col !== sc;
        this.pendingNotation = this.computeNotation({
            row: sr,
            col: sc
        }, {
            row: row,
            col: col
        }, piece, isCapture);
        // Record capture
        if (clickedPiece) this.captures[this.turn].push(clickedPiece.type);
        else if (piece.type === 'P' && col !== sc) this.captures[this.turn].push('P'); // en passant
        // Execute move
        this.board.setCell(row, col, piece);
        this.board.setCell(sr, sc, null);
        // En passant capture
        if (piece.type === 'P' && col !== sc && clickedPiece === null) this.board.setCell(sr, col, null);
        // Castling rook move
        if (piece.type === 'K' && Math.abs(col - sc) === 2) {
            if (col === 6) {
                this.board.setCell(row, 5, this.board.getCell(row, 7));
                this.board.setCell(row, 7, null);
            } else {
                this.board.setCell(row, 3, this.board.getCell(row, 0));
                this.board.setCell(row, 0, null);
            }
        }
        // Update castling rights
        this.updateCastlingRights(piece.type, piece.color, sr, sc, row, col);
        // Set last move
        this.lastMove = {
            from: {
                row: sr,
                col: sc
            },
            to: {
                row: row,
                col: col
            },
            piece: piece
        };
        // Promotion check
        const promotionRow = piece.color === 'w' ? 0 : 7;
        if (piece.type === 'P' && row === promotionRow) {
            this.pendingPromotion = {
                row: row,
                col: col
            };
            this.selected = null;
            this.legalMoves = [];
            return;
        }
        this.finishTurn();
        this.recordMove(this.pendingNotation);
    }
    promote(pieceType) {
        if (!this.pendingPromotion) return;
        const { row: row, col: col } = this.pendingPromotion;
        this.board.setCell(row, col, {
            type: pieceType,
            color: this.turn
        });
        this.pendingPromotion = null;
        this.pendingNotation += '=' + pieceType;
        this.finishTurn();
        this.recordMove(this.pendingNotation);
    }
    exportMoves() {
        let result = '';
        for(let i = 0; i < this.moveLog.length; i++){
            if (i % 2 === 0) {
                if (i > 0) result += ' ';
                result += `${i / 2 + 1}. `;
            } else result += ' ';
            result += this.moveLog[i];
        }
        return result;
    }
    importMoves(movetext) {
        const tokens = movetext.replace(/\d+\.{1,3}\s*/g, '').trim().split(/\s+/).filter((s)=>s.length > 0 && !s.match(/^(1-0|0-1|1\/2-1\/2|\*)$/));
        this.reset();
        for(let i = 0; i < tokens.length; i++)if (!this.applyNotation(tokens[i])) {
            this.selected = null;
            this.legalMoves = [];
            return {
                success: false,
                error: `Move ${i + 1}: ${tokens[i]}`
            };
        }
        return {
            success: true
        };
    }
    applyNotation(notation) {
        if (this.status === 'checkmate' || this.status === 'stalemate') return false;
        let s = notation.replace(/[+#]/g, '');
        // Castling
        if (s === 'O-O' || s === 'O-O-O') {
            const king = (0, $4ab56ab556188d29$export$51123a03fba7994c)(this.board, this.turn);
            const targetCol = s === 'O-O' ? 6 : 2;
            return this.tryMove(king, {
                row: king.row,
                col: targetCol
            });
        }
        // Promotion
        let promotion;
        const promoMatch = s.match(/=([QRBN])$/);
        if (promoMatch) {
            promotion = promoMatch[1];
            s = s.slice(0, -2);
        }
        // Piece type
        let pieceType = 'P';
        if (/^[KQRBN]/.test(s)) {
            pieceType = s[0];
            s = s.slice(1);
        }
        // Remove capture marker
        s = s.replace('x', '');
        // Parse destination (file + rank at end)
        const destMatch = s.match(/([a-h])(-?\d+)$/);
        if (!destMatch) return false;
        const destCol = destMatch[1].charCodeAt(0) - 97;
        const destRow = 8 - parseInt(destMatch[2], 10);
        // Parse disambiguation prefix
        const prefix = s.slice(0, s.length - destMatch[0].length);
        let disambigCol;
        let disambigRow;
        if (prefix.length > 0) {
            const dm = prefix.match(/^([a-h])?(-?\d+)?$/);
            if (!dm) return false;
            if (dm[1]) disambigCol = dm[1].charCodeAt(0) - 97;
            if (dm[2] !== undefined) disambigRow = 8 - parseInt(dm[2], 10);
        }
        // Find matching piece with legal move to destination
        const to = {
            row: destRow,
            col: destCol
        };
        for(let r = this.board.top - 1; r <= this.board.bottom + 1; r++)for(let c = 0; c < 8; c++){
            const cell = this.board.getCell(r, c);
            if (!cell || cell.color !== this.turn || cell.type !== pieceType) continue;
            if (disambigCol !== undefined && c !== disambigCol) continue;
            if (disambigRow !== undefined && r !== disambigRow) continue;
            const moves = (0, $4ab56ab556188d29$export$fc786a30b8974380)(this.board, {
                row: r,
                col: c
            }, this.lastMove, this.castlingRights);
            if (moves.some((m)=>m.row === to.row && m.col === to.col)) return this.tryMove({
                row: r,
                col: c
            }, to, promotion);
        }
        return false;
    }
    tryMove(from, to, promotion) {
        const turnBefore = this.turn;
        this.click(from.row, from.col);
        if (!this.selected || this.selected.row !== from.row || this.selected.col !== from.col) {
            this.selected = null;
            this.legalMoves = [];
            return false;
        }
        this.click(to.row, to.col);
        if (this.pendingPromotion) {
            if (!promotion) return false;
            this.promote(promotion);
        }
        return this.turn !== turnBefore;
    }
    kingPos(color) {
        return (0, $4ab56ab556188d29$export$51123a03fba7994c)(this.board, color);
    }
    finishTurn() {
        this.selected = null;
        this.legalMoves = [];
        this.turn = this.turn === 'w' ? 'b' : 'w';
        this.status = (0, $4ab56ab556188d29$export$2919e2d100ec73fb)(this.board, this.turn, this.lastMove, this.castlingRights);
    }
    computeNotation(from, to, piece, isCapture) {
        const file = 'abcdefgh';
        const rank = (r)=>String(8 - r);
        // Castling
        if (piece.type === 'K' && Math.abs(to.col - from.col) === 2) return to.col === 6 ? 'O-O' : 'O-O-O';
        let notation = '';
        if (piece.type === 'P') {
            if (isCapture) notation += file[from.col];
        } else {
            notation += piece.type;
            notation += this.disambiguate(piece, from, to);
        }
        if (isCapture) notation += 'x';
        notation += file[to.col] + rank(to.row);
        return notation;
    }
    disambiguate(piece, from, to) {
        const file = 'abcdefgh';
        const ambiguous = [];
        for(let r = this.board.top - 1; r <= this.board.bottom + 1; r++)for(let c = 0; c < 8; c++){
            if (r === from.row && c === from.col) continue;
            const cell = this.board.getCell(r, c);
            if (cell && cell.type === piece.type && cell.color === piece.color) {
                const moves = (0, $4ab56ab556188d29$export$fc786a30b8974380)(this.board, {
                    row: r,
                    col: c
                }, this.lastMove, this.castlingRights);
                if (moves.some((m)=>m.row === to.row && m.col === to.col)) ambiguous.push({
                    row: r,
                    col: c
                });
            }
        }
        if (ambiguous.length === 0) return '';
        const sameFile = ambiguous.some((p)=>p.col === from.col);
        const sameRank = ambiguous.some((p)=>p.row === from.row);
        if (!sameFile) return file[from.col];
        if (!sameRank) return String(8 - from.row);
        return file[from.col] + String(8 - from.row);
    }
    recordMove(notation) {
        if (this.status === 'checkmate') notation += '#';
        else if (this.status === 'check') notation += '+';
        this.moveLog.push(notation);
    }
    updateCastlingRights(type, color, fromRow, fromCol, toRow, toCol) {
        if (type === 'K') {
            if (color === 'w') {
                this.castlingRights.wK = false;
                this.castlingRights.wQ = false;
            } else {
                this.castlingRights.bK = false;
                this.castlingRights.bQ = false;
            }
        }
        if (type === 'R') {
            if (color === 'w' && fromRow === 7) {
                if (fromCol === 7) this.castlingRights.wK = false;
                if (fromCol === 0) this.castlingRights.wQ = false;
            }
            if (color === 'b' && fromRow === 0) {
                if (fromCol === 7) this.castlingRights.bK = false;
                if (fromCol === 0) this.castlingRights.bQ = false;
            }
        }
        // If a rook is captured on its original square
        if (toRow === 0 && toCol === 0) this.castlingRights.bQ = false;
        if (toRow === 0 && toCol === 7) this.castlingRights.bK = false;
        if (toRow === 7 && toCol === 0) this.castlingRights.wQ = false;
        if (toRow === 7 && toCol === 7) this.castlingRights.wK = false;
    }
    constructor(){
        this.board = new (0, $b2ebc7535321c5c8$export$5f0f8d492a153731)();
        this.selected = null;
        this.turn = 'w';
        this.lastMove = null;
        this.castlingRights = {
            wK: true,
            wQ: true,
            bK: true,
            bQ: true
        };
        this.status = 'playing';
        this.legalMoves = [];
        this.pendingPromotion = null;
        this.moveLog = [];
        this.captures = {
            w: [],
            b: []
        };
        this.pendingNotation = '';
    }
}


// Pawn symbols include U+FE0E (VS15) to force text presentation in Firefox
const $e3d6ee63ed1479b9$var$SYMBOLS = {
    'w-K': "\u2654",
    'w-Q': "\u2655",
    'w-R': "\u2656",
    'w-B': "\u2657",
    'w-N': "\u2658",
    'w-P': "\u2659\uFE0E",
    'b-K': "\u265A",
    'b-Q': "\u265B",
    'b-R': "\u265C",
    'b-B': "\u265D",
    'b-N': "\u265E",
    'b-P': "\u265F\uFE0E"
};
function $e3d6ee63ed1479b9$var$symbol(piece) {
    return $e3d6ee63ed1479b9$var$SYMBOLS[`${piece.color}-${piece.type}`];
}
function $e3d6ee63ed1479b9$var$posInList(list, row, col) {
    return list.some((p)=>p.row === row && p.col === col);
}
function $e3d6ee63ed1479b9$export$b3890eb0ae9dca99(state, topRow, visibleRows, container, onSquareClick, flipped = false) {
    container.innerHTML = '';
    // Check king position for highlighting
    let checkKingPos = null;
    if (state.status === 'check' || state.status === 'checkmate') checkKingPos = state.kingPos(state.turn);
    const wrapper = document.createElement('div');
    wrapper.className = 'board-wrapper';
    for(let i = 0; i < visibleRows; i++){
        const row = flipped ? topRow + visibleRows - 1 - i : topRow + i;
        const rowEl = document.createElement('div');
        rowEl.className = 'board-row';
        if (row === 0) rowEl.classList.add(flipped ? 'board-row--bottom' : 'board-row--top');
        if (row === 7) rowEl.classList.add(flipped ? 'board-row--top' : 'board-row--bottom');
        const label = document.createElement('div');
        const isOriginal = row >= 0 && row <= 7;
        label.className = `row-label${isOriginal ? ' row-label--original' : ''}`;
        label.textContent = String(8 - row);
        rowEl.appendChild(label);
        for(let c = 0; c < 8; c++){
            const col = flipped ? 7 - c : c;
            const sq = document.createElement('div');
            const light = (row + col) % 2 === 0;
            sq.className = `square ${light ? 'light' : 'dark'}`;
            if (state.selected?.row === row && state.selected?.col === col) sq.classList.add('selected');
            if (checkKingPos && checkKingPos.row === row && checkKingPos.col === col) sq.classList.add('in-check');
            // Legal move highlighting
            if ($e3d6ee63ed1479b9$var$posInList(state.legalMoves, row, col)) {
                const targetPiece = state.board.getCell(row, col);
                sq.classList.add(targetPiece ? 'legal-capture' : 'legal-move');
            }
            const piece = state.board.getCell(row, col);
            if (piece !== null) {
                const span = document.createElement('span');
                span.className = `piece ${piece.color === 'w' ? 'white' : 'black'}`;
                span.textContent = $e3d6ee63ed1479b9$var$symbol(piece);
                sq.appendChild(span);
            }
            sq.addEventListener('click', ()=>onSquareClick(row, col));
            rowEl.appendChild(sq);
        }
        wrapper.appendChild(rowEl);
    }
    container.appendChild(wrapper);
}
function $e3d6ee63ed1479b9$export$a9a883954ed92cd9(color, onSelect) {
    const overlay = document.createElement('div');
    overlay.className = 'promotion-overlay';
    const dialog = document.createElement('div');
    dialog.className = 'promotion-dialog';
    const pieces = [
        'Q',
        'R',
        'B',
        'N'
    ];
    for (const type of pieces){
        const btn = document.createElement('div');
        btn.className = `promo-btn ${color === 'w' ? 'white' : 'black'}`;
        btn.textContent = $e3d6ee63ed1479b9$var$SYMBOLS[`${color}-${type}`];
        btn.addEventListener('click', ()=>onSelect(type));
        dialog.appendChild(btn);
    }
    overlay.appendChild(dialog);
    return overlay;
}
function $e3d6ee63ed1479b9$export$58d62ba92c708e52(el, moveLog) {
    el.innerHTML = '';
    const totalMoves = Math.ceil(moveLog.length / 2);
    for(let i = totalMoves - 1; i >= 0; i--){
        const white = moveLog[i * 2];
        const black = moveLog[i * 2 + 1] ?? '';
        const line = document.createElement('div');
        line.className = 'move-line';
        const num = document.createElement('span');
        num.className = 'move-num';
        num.textContent = `${i + 1}.`;
        const w = document.createElement('span');
        w.className = 'move-ply';
        w.textContent = white;
        line.appendChild(num);
        line.appendChild(w);
        if (black) {
            const b = document.createElement('span');
            b.className = 'move-ply';
            b.textContent = black;
            line.appendChild(b);
        }
        el.appendChild(line);
    }
}
function $e3d6ee63ed1479b9$var$buildCaptureLine(color, captures) {
    const line = document.createElement('div');
    line.className = `capture-line cap-${color === 'w' ? 'white' : 'black'}`;
    // King icon for the player
    const king = document.createElement('span');
    king.className = 'cap-king';
    king.textContent = $e3d6ee63ed1479b9$var$SYMBOLS[`${color}-K`];
    line.appendChild(king);
    // Group captures by type, ordered by value
    const order = [
        'Q',
        'R',
        'B',
        'N',
        'P'
    ];
    const counts = new Map();
    for (const t of captures)counts.set(t, (counts.get(t) ?? 0) + 1);
    const opponent = color === 'w' ? 'b' : 'w';
    for (const t of order){
        const n = counts.get(t);
        if (!n) continue;
        const span = document.createElement('span');
        span.className = 'cap-piece';
        span.textContent = $e3d6ee63ed1479b9$var$SYMBOLS[`${opponent}-${t}`] + (n > 1 ? n : '');
        line.appendChild(span);
    }
    return line;
}
function $e3d6ee63ed1479b9$export$601d92ebfc9ec5f0(el, state) {
    el.innerHTML = '';
    el.appendChild($e3d6ee63ed1479b9$var$buildCaptureLine('w', state.captures.w));
    el.appendChild($e3d6ee63ed1479b9$var$buildCaptureLine('b', state.captures.b));
}
function $e3d6ee63ed1479b9$export$dd127eb7207846ef(el, state) {
    const turnName = state.turn === 'w' ? 'White' : 'Black';
    el.classList.remove('check', 'gameover');
    switch(state.status){
        case 'playing':
            el.textContent = `${turnName} to move`;
            break;
        case 'check':
            el.textContent = `${turnName} is in check!`;
            el.classList.add('check');
            break;
        case 'checkmate':
            {
                const winner = state.turn === 'w' ? 'Black' : 'White';
                el.textContent = `Checkmate! ${winner} wins`;
                el.classList.add('gameover');
                break;
            }
        case 'stalemate':
            el.textContent = "Stalemate \u2014 draw";
            el.classList.add('gameover');
            break;
    }
}


function $ad2bcec7a0192558$var$computeLayout() {
    const isMobile = window.innerWidth <= 600;
    const availWidth = isMobile ? window.innerWidth : window.innerWidth - 180;
    const maxByWidth = Math.floor(availWidth / 8.5); // 8 squares + half-square label
    const maxByHeight = Math.floor(window.innerHeight / 12);
    const sq = Math.min(maxByWidth, maxByHeight, 72);
    const rows = Math.floor(window.innerHeight / sq);
    return {
        sq: sq,
        rows: rows
    };
}
let { sq: $ad2bcec7a0192558$var$SQUARE_SIZE, rows: $ad2bcec7a0192558$var$VISIBLE_ROWS } = $ad2bcec7a0192558$var$computeLayout();
const $ad2bcec7a0192558$var$state = new (0, $e46db5192eb49d53$export$eb5ccdbd077479c)();
let $ad2bcec7a0192558$var$scrollY = -2 * $ad2bcec7a0192558$var$SQUARE_SIZE; // continuous pixel offset (replaces discrete topRow)
let $ad2bcec7a0192558$var$flipped = false;
const $ad2bcec7a0192558$var$app = document.getElementById('app');
const $ad2bcec7a0192558$var$statusEl = document.getElementById('status');
const $ad2bcec7a0192558$var$moveLogEl = document.getElementById('move-log');
const $ad2bcec7a0192558$var$capturesEl = document.getElementById('captures');
$ad2bcec7a0192558$var$app.tabIndex = 0;
/* ── Layout ── */ function $ad2bcec7a0192558$var$applyLayout() {
    document.documentElement.style.setProperty('--sq', $ad2bcec7a0192558$var$SQUARE_SIZE + 'px');
    $ad2bcec7a0192558$var$app.style.height = `${$ad2bcec7a0192558$var$VISIBLE_ROWS * $ad2bcec7a0192558$var$SQUARE_SIZE}px`;
}
$ad2bcec7a0192558$var$applyLayout();
/* ── Rendering ── */ let $ad2bcec7a0192558$var$wrapperEl = null;
let $ad2bcec7a0192558$var$lastRenderedTopRow = null;
function $ad2bcec7a0192558$var$getTopRow() {
    return Math.floor($ad2bcec7a0192558$var$scrollY / $ad2bcec7a0192558$var$SQUARE_SIZE);
}
function $ad2bcec7a0192558$var$applyScroll() {
    const top = $ad2bcec7a0192558$var$getTopRow();
    const frac = $ad2bcec7a0192558$var$scrollY - top * $ad2bcec7a0192558$var$SQUARE_SIZE; // always in [0, SQUARE_SIZE)
    if (top !== $ad2bcec7a0192558$var$lastRenderedTopRow || !$ad2bcec7a0192558$var$wrapperEl) {
        $ad2bcec7a0192558$var$renderBoard();
        $ad2bcec7a0192558$var$lastRenderedTopRow = top;
    }
    if ($ad2bcec7a0192558$var$wrapperEl) {
        const offset = $ad2bcec7a0192558$var$flipped ? frac - $ad2bcec7a0192558$var$SQUARE_SIZE : -frac;
        $ad2bcec7a0192558$var$wrapperEl.style.transform = `translateY(${offset}px)`;
    }
}
function $ad2bcec7a0192558$var$renderBoard() {
    const top = $ad2bcec7a0192558$var$getTopRow();
    // Render one extra row so partial rows are visible during smooth scroll
    (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)($ad2bcec7a0192558$var$state, top, $ad2bcec7a0192558$var$VISIBLE_ROWS + 1, $ad2bcec7a0192558$var$app, (row, col)=>{
        $ad2bcec7a0192558$var$state.click(row, col);
        $ad2bcec7a0192558$var$fullUpdate();
    }, $ad2bcec7a0192558$var$flipped);
    $ad2bcec7a0192558$var$wrapperEl = $ad2bcec7a0192558$var$app.querySelector('.board-wrapper');
}
function $ad2bcec7a0192558$var$fullUpdate() {
    $ad2bcec7a0192558$var$lastRenderedTopRow = null; // force DOM rebuild
    $ad2bcec7a0192558$var$applyScroll();
    (0, $e3d6ee63ed1479b9$export$601d92ebfc9ec5f0)($ad2bcec7a0192558$var$capturesEl, $ad2bcec7a0192558$var$state);
    (0, $e3d6ee63ed1479b9$export$dd127eb7207846ef)($ad2bcec7a0192558$var$statusEl, $ad2bcec7a0192558$var$state);
    (0, $e3d6ee63ed1479b9$export$58d62ba92c708e52)($ad2bcec7a0192558$var$moveLogEl, $ad2bcec7a0192558$var$state.moveLog);
    const btnExport = document.getElementById('btn-export');
    btnExport.disabled = $ad2bcec7a0192558$var$state.moveLog.length === 0;
    // Promotion dialog
    const existing = document.querySelector('.promotion-overlay');
    if (existing) existing.remove();
    if ($ad2bcec7a0192558$var$state.pendingPromotion) {
        const dialog = (0, $e3d6ee63ed1479b9$export$a9a883954ed92cd9)($ad2bcec7a0192558$var$state.turn, (type)=>{
            $ad2bcec7a0192558$var$state.promote(type);
            $ad2bcec7a0192558$var$fullUpdate();
        });
        document.body.appendChild(dialog);
    }
}
/* ── Momentum / inertia ── */ let $ad2bcec7a0192558$var$velocity = 0;
let $ad2bcec7a0192558$var$rafId = null;
function $ad2bcec7a0192558$var$stopMomentum() {
    if ($ad2bcec7a0192558$var$rafId !== null) {
        cancelAnimationFrame($ad2bcec7a0192558$var$rafId);
        $ad2bcec7a0192558$var$rafId = null;
    }
    $ad2bcec7a0192558$var$velocity = 0;
}
function $ad2bcec7a0192558$var$startMomentum() {
    const FRICTION = 0.95;
    const MIN_VELOCITY = 0.5;
    function tick() {
        $ad2bcec7a0192558$var$velocity *= FRICTION;
        if (Math.abs($ad2bcec7a0192558$var$velocity) < MIN_VELOCITY) {
            $ad2bcec7a0192558$var$velocity = 0;
            $ad2bcec7a0192558$var$rafId = null;
            return;
        }
        $ad2bcec7a0192558$var$scrollY += $ad2bcec7a0192558$var$velocity;
        $ad2bcec7a0192558$var$applyScroll();
        $ad2bcec7a0192558$var$rafId = requestAnimationFrame(tick);
    }
    if (Math.abs($ad2bcec7a0192558$var$velocity) >= MIN_VELOCITY) $ad2bcec7a0192558$var$rafId = requestAnimationFrame(tick);
}
/* ── Smooth scroll animation (for keyboard) ── */ function $ad2bcec7a0192558$var$smoothScrollBy(delta) {
    $ad2bcec7a0192558$var$stopMomentum();
    const start = $ad2bcec7a0192558$var$scrollY;
    const startTime = performance.now();
    const duration = 150;
    function tick(now) {
        const t = Math.min((now - startTime) / duration, 1);
        const ease = t * (2 - t); // ease-out quadratic
        $ad2bcec7a0192558$var$scrollY = start + delta * ease;
        $ad2bcec7a0192558$var$applyScroll();
        if (t < 1) $ad2bcec7a0192558$var$rafId = requestAnimationFrame(tick);
        else $ad2bcec7a0192558$var$rafId = null;
    }
    $ad2bcec7a0192558$var$rafId = requestAnimationFrame(tick);
}
/* ── Input: wheel ── */ const $ad2bcec7a0192558$var$dir = ()=>$ad2bcec7a0192558$var$flipped ? -1 : 1;
$ad2bcec7a0192558$var$app.addEventListener('wheel', (e)=>{
    e.preventDefault();
    $ad2bcec7a0192558$var$stopMomentum();
    $ad2bcec7a0192558$var$scrollY += e.deltaY * $ad2bcec7a0192558$var$dir();
    $ad2bcec7a0192558$var$applyScroll();
}, {
    passive: false
});
/* ── Input: keyboard ── */ $ad2bcec7a0192558$var$app.addEventListener('keydown', (e)=>{
    if (e.key === 'ArrowUp') {
        e.preventDefault();
        $ad2bcec7a0192558$var$smoothScrollBy(-$ad2bcec7a0192558$var$SQUARE_SIZE * $ad2bcec7a0192558$var$dir());
    }
    if (e.key === 'ArrowDown') {
        e.preventDefault();
        $ad2bcec7a0192558$var$smoothScrollBy($ad2bcec7a0192558$var$SQUARE_SIZE * $ad2bcec7a0192558$var$dir());
    }
});
/* ── Input: touch (pointer events for reliable capture) ── */ const $ad2bcec7a0192558$var$DRAG_THRESHOLD = 8; // px before a touch becomes a drag
let $ad2bcec7a0192558$var$wasDragging = false;
let $ad2bcec7a0192558$var$dragState = null;
$ad2bcec7a0192558$var$app.addEventListener('pointerdown', (e)=>{
    if (e.pointerType !== 'touch') return;
    $ad2bcec7a0192558$var$stopMomentum();
    $ad2bcec7a0192558$var$wasDragging = false;
    $ad2bcec7a0192558$var$dragState = {
        pointerId: e.pointerId,
        startY: e.clientY,
        lastY: e.clientY,
        lastTime: performance.now(),
        velocity: 0,
        isDragging: false
    };
    $ad2bcec7a0192558$var$app.setPointerCapture(e.pointerId);
});
$ad2bcec7a0192558$var$app.addEventListener('pointermove', (e)=>{
    if (!$ad2bcec7a0192558$var$dragState || e.pointerId !== $ad2bcec7a0192558$var$dragState.pointerId) return;
    const y = e.clientY;
    const now = performance.now();
    if (!$ad2bcec7a0192558$var$dragState.isDragging) {
        if (Math.abs(y - $ad2bcec7a0192558$var$dragState.startY) > $ad2bcec7a0192558$var$DRAG_THRESHOLD) $ad2bcec7a0192558$var$dragState.isDragging = true;
        else return;
    }
    e.preventDefault();
    const dy = ($ad2bcec7a0192558$var$dragState.lastY - y) * $ad2bcec7a0192558$var$dir();
    const dt = now - $ad2bcec7a0192558$var$dragState.lastTime;
    if (dt > 0) {
        const instantV = dy / dt * 16;
        $ad2bcec7a0192558$var$dragState.velocity = $ad2bcec7a0192558$var$dragState.velocity * 0.4 + instantV * 0.6;
    }
    $ad2bcec7a0192558$var$scrollY += dy;
    $ad2bcec7a0192558$var$dragState.lastY = y;
    $ad2bcec7a0192558$var$dragState.lastTime = now;
    $ad2bcec7a0192558$var$applyScroll();
});
function $ad2bcec7a0192558$var$onPointerRelease(e) {
    if (!$ad2bcec7a0192558$var$dragState || e.pointerId !== $ad2bcec7a0192558$var$dragState.pointerId) return;
    if ($ad2bcec7a0192558$var$dragState.isDragging) {
        $ad2bcec7a0192558$var$wasDragging = true;
        const elapsed = performance.now() - $ad2bcec7a0192558$var$dragState.lastTime;
        $ad2bcec7a0192558$var$velocity = elapsed > 100 ? 0 : $ad2bcec7a0192558$var$dragState.velocity;
        $ad2bcec7a0192558$var$startMomentum();
    }
    $ad2bcec7a0192558$var$dragState = null;
}
$ad2bcec7a0192558$var$app.addEventListener('pointerup', $ad2bcec7a0192558$var$onPointerRelease);
$ad2bcec7a0192558$var$app.addEventListener('pointercancel', $ad2bcec7a0192558$var$onPointerRelease);
// Suppress click on squares after a drag gesture
$ad2bcec7a0192558$var$app.addEventListener('click', (e)=>{
    if ($ad2bcec7a0192558$var$wasDragging) {
        e.stopPropagation();
        $ad2bcec7a0192558$var$wasDragging = false;
    }
}, {
    capture: true
});
/* ── Resize ── */ window.addEventListener('resize', ()=>{
    const logicalRow = $ad2bcec7a0192558$var$scrollY / $ad2bcec7a0192558$var$SQUARE_SIZE;
    ({ sq: $ad2bcec7a0192558$var$SQUARE_SIZE, rows: $ad2bcec7a0192558$var$VISIBLE_ROWS } = $ad2bcec7a0192558$var$computeLayout());
    $ad2bcec7a0192558$var$scrollY = logicalRow * $ad2bcec7a0192558$var$SQUARE_SIZE;
    $ad2bcec7a0192558$var$applyLayout();
    $ad2bcec7a0192558$var$lastRenderedTopRow = null;
    $ad2bcec7a0192558$var$applyScroll();
});
/* ── Buttons ── */ document.getElementById('btn-reset').addEventListener('click', ()=>{
    $ad2bcec7a0192558$var$state.reset();
    $ad2bcec7a0192558$var$scrollY = -2 * $ad2bcec7a0192558$var$SQUARE_SIZE;
    $ad2bcec7a0192558$var$stopMomentum();
    $ad2bcec7a0192558$var$fullUpdate();
    $ad2bcec7a0192558$var$app.focus();
});
document.getElementById('btn-rotate').addEventListener('click', ()=>{
    $ad2bcec7a0192558$var$flipped = !$ad2bcec7a0192558$var$flipped;
    $ad2bcec7a0192558$var$fullUpdate();
    $ad2bcec7a0192558$var$app.focus();
});
document.getElementById('btn-export').addEventListener('click', ()=>{
    const text = $ad2bcec7a0192558$var$state.exportMoves();
    navigator.clipboard.writeText(text).then(()=>{
        const btn = document.getElementById('btn-export');
        btn.textContent = '\u2713';
        setTimeout(()=>{
            btn.textContent = '\u2197';
        }, 1500);
    });
    $ad2bcec7a0192558$var$app.focus();
});
document.getElementById('btn-import').addEventListener('click', ()=>{
    const input = prompt('Paste moves:');
    if (input === null || input.trim() === '') return;
    const result = $ad2bcec7a0192558$var$state.importMoves(input);
    $ad2bcec7a0192558$var$scrollY = -2 * $ad2bcec7a0192558$var$SQUARE_SIZE;
    $ad2bcec7a0192558$var$stopMomentum();
    $ad2bcec7a0192558$var$fullUpdate();
    if (!result.success) alert(`Invalid move: ${result.error}`);
    $ad2bcec7a0192558$var$app.focus();
});
// Sidebar toggle (mobile)
const $ad2bcec7a0192558$var$sidebar = document.getElementById('sidebar');
const $ad2bcec7a0192558$var$btnSidebarOpen = document.getElementById('btn-sidebar-open');
const $ad2bcec7a0192558$var$btnSidebarClose = document.getElementById('btn-sidebar-close');
$ad2bcec7a0192558$var$btnSidebarOpen.addEventListener('click', ()=>{
    $ad2bcec7a0192558$var$sidebar.classList.add('open');
    $ad2bcec7a0192558$var$btnSidebarOpen.classList.add('hidden');
});
$ad2bcec7a0192558$var$btnSidebarClose.addEventListener('click', ()=>{
    $ad2bcec7a0192558$var$sidebar.classList.remove('open');
    $ad2bcec7a0192558$var$btnSidebarOpen.classList.remove('hidden');
});
/* ── Init ── */ $ad2bcec7a0192558$var$fullUpdate();
$ad2bcec7a0192558$var$app.focus();


//# sourceMappingURL=infinite-armada-chess.51f7a98f.js.map
